Namespace 'Customer.Users'

class Customer.Users.SocialProfileView extends Backbone.View
  className: 'social-profile'
  events:
    'click .remove-profile-button': 'removeSocialUser'

  initialize: (socialUser) ->
    @socialUser = socialUser

  render: ->
    @$el.html @template
      socialUser: @socialUser
    @

  removeSocialUser: ->
    @trigger('profile:remove-social-user', @socialUser)
